import { z } from "zod";
import { EntityCloseStatus } from "./entity";
import { OrganizationServicesOffered } from "./organization";

export enum OrganizationEntityPriority {
    LOW = "low",
    MEDIUM = "medium",
    HIGH = "high",
    URGENT = "urgent",
}

export const OrganizationEntitySchema = z.object({
    organizationId: z.string().uuid(),
    entityId: z.number(),
    closeStatus: z.nativeEnum(EntityCloseStatus).nullable(),
    closeDate: z.string().nullable(),
    note: z.string().nullable(),
    services: z.array(z.nativeEnum(OrganizationServicesOffered)).nullable(),
    priority: z.nativeEnum(OrganizationEntityPriority).nullable(),
    dueDate: z.string().date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type OrganizationEntityEntity = z.infer<typeof OrganizationEntitySchema>;
